import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthControllerService} from "../../../services/auth-controller/auth-controller.service";
import { AppWidgetModule } from 'app/components/widgets/widget.module';
import { BpaExternalModule } from 'bpa_client_src/app/bpa-external.module';
import { SharedModule } from 'app/shared.module';

@Component({
    standalone: true,
    selector: 'login-page',
    templateUrl: `./dashboard.component.html`,
    imports: [SharedModule, AppWidgetModule, BpaExternalModule]
})
export class DashboardPage implements OnInit {
    currentUserIsAdmin: boolean;
    currentUserIsUserAdmin: boolean;
    currentUserIsAnalyst: boolean;
    currentUserIsInstitutionManager: boolean;

    constructor(private authService: AuthControllerService,
                private router: Router) {
    }

    ngOnInit(): void {
		this.bindRoles = this.bindRoles.bind(this);
		this.authService.subscribeForTokenChange(this.bindRoles);
		this.bindRoles();
	}

	ngOnDestroy(): void {
		this.authService.unsubscribe(this.bindRoles);
	}

    bindRoles() {
		const loggedUser = this.authService.loggedUser();
		if (!loggedUser) {
			this.currentUserIsAdmin = false;
			this.currentUserIsAnalyst = false;
			this.currentUserIsUserAdmin = false;
			this.currentUserIsInstitutionManager = false;
			return;
		}
        this.currentUserIsAdmin = loggedUser.roles.indexOf('sysadmin') > -1;
        this.currentUserIsAnalyst = loggedUser.roles.indexOf('stat_analyst') > -1
        this.currentUserIsUserAdmin = loggedUser.roles.indexOf('user_admin') > -1
        this.currentUserIsInstitutionManager = loggedUser.roles.indexOf('superinspector') > -1
    }
}
